import "./productDetailSection.scss";

const ProductDetailSection = ({ product, reviewPromo }) => {
    if (!product) return null;

    return (
        <div className="product-detail-section">
            <div className="product-main">
                <div className="product-image">
                    {product.image ? (
                        <img src={product.image} alt={product.name} />
                    ) : (
                        <div className="placeholder-image">
                            <i className="bi bi-image"></i>
                        </div>
                    )}
                </div>
                <div className="product-info">
                    {product.seller && (
                        <div className="product-seller">{product.seller}</div>
                    )}
                    <h3 className="product-name">{product.name}</h3>
                    {product.option && (
                        <div className="product-option">{product.option}</div>
                    )}
                    {Array.isArray(product.customerInputPairs) &&
                        product.customerInputPairs.map((pair, idx) => (
                            <div
                                className="product-option customer-input-pair"
                                key={`ci-${idx}`}
                            >
                                {pair.question} : {pair.answer || "-"}
                            </div>
                        ))}
                    {product.quantity > 0 && (
                        <div className="product-quantity">수량: {product.quantity}</div>
                    )}
                    <div className="product-pricing">
                        <span className="product-price">
                            {product.price.toLocaleString()}원
                        </span>
                        {product.discount_price && (
                            <>
                                <span className="product-original-price">
                                    {product.discount_price.toLocaleString()}원
                                </span>
                                {product.discount_badge && (
                                    <span className="discount-badge">
                                        {product.discount_badge}
                                    </span>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetailSection;
